module.exports = __webpack_public_path__ + "img/21MY_EP_DEU_INTENSE-U02_4WD_seat_synthetic-leather_black.5827f580.jpg";